import {
  Content,
  Holder,
  LeftHolder,
  MiddleHolder,
  RightHolder,
  LeftPic,
  LeftBottomHolder,
  TaylorPic,
  Text2,
  Text4,
  BestImage,
  FourImage,
  CardImage,
  List,
  ListItem,
  AboutLink,
  BackButton,
  BackIcon
} from "./Postmark.style"
import TaylorIcon from "./taylor.svg"
import CardIcon from "./card.svg"
import BestIcon from "./best.svg"
import FourIcon from "./acre.svg"
import { AboutPath } from "../../../routes"
import Arrows from "../../../components/Icons/navy_double_arrow_left.svg"

const pageVariants = {
  initial: {
    opacity: 0
  },
  in: {
    opacity: 1
  },
  out: {
    opacity: 0
  }
}

const pageTransition = {
  ease: "easeIn",
  duration: 0.7
}

export default function Postmark() {
  return (
    <Holder
      initial="initial"
      animate="in"
      exit="out"
      variants={pageVariants}
      transition={pageTransition}
    >
      <Content>
        <LeftHolder>
          <LeftPic />
          <LeftBottomHolder>
            <TaylorPic src={TaylorIcon} />
            <Text4>
              At the point where east meets west, Postmark brings a flourishing new neighbourhood to
              the heart of central London.
            </Text4>
          </LeftBottomHolder>
        </LeftHolder>
        <MiddleHolder>
          <BestImage src={BestIcon} />
          <Text2>
            Postmark has all the buzz of a central London destination, yet with a distinctly local
            feel. Here you’ll find a community of people from all walks of life, each bringing
            something different to a neighbourhood that’s cultured, creative and connected.
          </Text2>
          <Text2>
            Spanning WC1 and EC1, Postmark melds the high-end heritage of west London with the
            pulsing creative energy of the east. Explore the literary streets of Bloomsbury or the
            acclaimed design shops and family-run restaurants of Clerkenwell.
          </Text2>
          <FourImage src={FourIcon} />
          <Text2>
            Choose from local independent boutiques or famous shopping destinations like Bond Street
            and Covent Garden. Not forgetting an arts and cultural scene that’s the envy of the
            world, all within reach on foot, by bike, or just a short ride away on public transport.
            And to relax, Postmark’s new public square is the perfect place to meet with friends, or
            you can head to the neighbourhood’s many green parks.
          </Text2>
          <Text2>
            Folio Gardens is the exciting third phase to launch at Postmark, enhancing the already
            established phases with a brand new bustling public square at the heart of Farringdon,
            complete with landscaped gardens and a lively mix of shops, workspaces and cafés for the
            whole community to enjoy.
          </Text2>
        </MiddleHolder>
        <RightHolder>
          <CardImage src={CardIcon} />
          <List>
            <ListItem>
              143 homes designed especially for Folio Gardens, across 3 buildings*
            </ListItem>
            <ListItem>
              Architecture by White Ink with two exclusive interior palettes by WISH
            </ListItem>
            <ListItem>
              Range of studio, one, two and three bedroom residences with balcony, wintergarden or
              terrace spaces
            </ListItem>
            <ListItem>
              Access to exclusive state-of-the-art Wellness Centre with pool, sauna, steam room,
              gym, fitness studio and treatment room
            </ListItem>
            <ListItem>
              Additional resident amenities include private roof terraces, 24/7 concierge and secure
              cycle storage
            </ListItem>
            <ListItem>
              Landscaped gardens and outdoor public spaces designed by Tri External Landscape Design
              LLP
            </ListItem>
            <ListItem>
              New public realm surrounded by 7,425 sq ft of retail and commercial spaces with an
              additional 6,000 sq ft in the next phase
            </ListItem>
          </List>
        </RightHolder>
      </Content>
      <AboutLink to={AboutPath}>
        <BackButton>
          <BackIcon src={Arrows} />
        </BackButton>
      </AboutLink>
    </Holder>
  )
}
